export default __webpack_public_path__ + "static/media/BestFree.1cfa40be.jpg";